import { createAction, props } from '@ngrx/store';

export const GET_PACKAGE_DETAIL_BY_ID =
  '[PackageDetail] Get PackageDetail By ID';
export const GET_PACKAGE_DETAIL_BY_ID_SUCCESS =
  '[PackageDetail] Get PackageDetail By ID Success';
export const GET_PACKAGE_DETAIL_BY_ID_FAILURE =
  '[PackageDetail] Get PackageDetail By ID Failure';

export const GET_PACKAGE_DETAIL_BY_SLUG =
  '[PackageDetail] Get PackageDetail By Slug';
export const GET_PACKAGE_DETAIL_BY_SLUG_SUCCESS =
  '[PackageDetail] Get PackageDetail By Slug Success';
export const GET_PACKAGE_DETAIL_BY_SLUG_FAILURE =
  '[PackageDetail] Get PackageDetail By Slug Failure';

export const getPackageDetailById = createAction(
  GET_PACKAGE_DETAIL_BY_ID,
  props<{ id: string }>()
);

export const getPackageDetailByIdSuccess = createAction(
  GET_PACKAGE_DETAIL_BY_ID_SUCCESS,
  props<{ data: any }>()
);

export const getPackageDetailByIdFailure = createAction(
  GET_PACKAGE_DETAIL_BY_ID_FAILURE,
  props<{ data: any }>()
);

export const getPackageDetailBySlug = createAction(
  GET_PACKAGE_DETAIL_BY_SLUG,
  props<{ slug: string }>()
);

export const getPackageDetailBySlugSuccess = createAction(
  GET_PACKAGE_DETAIL_BY_SLUG_SUCCESS,
  props<{ data: any }>()
);

export const getPackageDetailBySlugFailure = createAction(
  GET_PACKAGE_DETAIL_BY_SLUG_FAILURE,
  props<{ data: any }>()
);


export const getDealDetails = createAction(
  '[Package Detail] Get Deal Details',
  props<{ slug: string }>()
);

export const getDealDetailsSuccess = createAction(
  '[Package Detail] Get Deal Details Success',
  props<{ data: any }>() 
);

export const getDealDetailsFailure = createAction(
  '[Package Detail] Get Deal Details Failure',
  props<{ error: any }>()
);